export const analyticsDb = new Proxy({
  getRecordsForSync: async () => [],
  addRecord: () => undefined,
  deleteSynced: async () => [],
}, () => {})
